module.exports = __webpack_public_path__ + "static/media/AS-logo.ec8def8f.svg";